(function () {
  const section_instances = new Map();

  function destroy_section(section_id) {
    const entry = section_instances.get(section_id);
    if (!entry) return;
    if (entry.swiper) {
      entry.swiper.destroy(true, true);
    }
    section_instances.delete(section_id);
  }

  function parse_slides(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function update_thumb(entry, immediate) {
    const thumb_el = entry.thumb_el;
    const swiper = entry.swiper;
    if (!thumb_el || !swiper) return;

    const count = entry.slide_count;
    if (count < 1) return;

    let ratio;
    if (count === 1) {
      ratio = 1;
    } else if (swiper.params.loop) {
      ratio = (((swiper.realIndex || 0) % count) + 1) / count;
    } else {
      ratio = (swiper.progress * (count - 1) + 1) / count;
    }

    ratio = Math.min(1, Math.max(1 / count, ratio));
    thumb_el.style.transition = immediate ? "none" : "";
    thumb_el.style.width = ratio * 100 + "%";
  }

  function create_section(section_el) {
    if (typeof window.Swiper !== "function") return;

    const section_id = section_el.dataset.sectionId;
    if (!section_id) return;

    destroy_section(section_id);

    const swiper_el = section_el.querySelector("[data-jmc-swiper]");
    if (!swiper_el) return;

    const enable_loop = section_el.dataset.loop === "true";
    const enable_autoplay = section_el.dataset.autoplay === "true";
    const autoplay_delay = Math.max(1, Number(section_el.dataset.autoplayDelay || 5)) * 1000;
    const space_between = Number(section_el.dataset.space || 16);
    const space_between_m = Number(section_el.dataset.spaceM || 12);
    const speed = Number(section_el.dataset.speed || 600);
    const initial_slide = Number(section_el.dataset.initial || 0);
    const slides_per_view = parse_slides(section_el.dataset.slides, 3);
    const slides_per_view_m = parse_slides(section_el.dataset.slidesM, 1.2);
    const reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const original_slides = Array.from(swiper_el.querySelectorAll(".jq3x-mc__slide"));
    const slide_count = original_slides.length;
    if (slide_count === 0) return;

    const prev_el = section_el.querySelector("[data-jmc-prev]");
    const next_el = section_el.querySelector("[data-jmc-next]");
    const thumb_el = section_el.querySelector("[data-jmc-thumb]");
    const loop_enabled = enable_loop && slide_count > 1;

    if (loop_enabled) {
      const wrapper_el = swiper_el.querySelector(".swiper-wrapper");
      // This Swiper build moves slides to loop instead of cloning them.
      // loopedSlides is ceil(slidesPerView). After init the active slide sits
      // at that index, and loopFix strips the left side whenever
      // activeIndex > length - 2 * loopedSlides. Keep at least 3 buffers so
      // a centered 4.5-up slide still has cards on its left.
      const loop_buffer = Math.ceil(Math.max(slides_per_view, slides_per_view_m));
      const min_slides = loop_buffer * 3;
      let guard = 0;
      while (wrapper_el.querySelectorAll(".jq3x-mc__slide").length < min_slides && guard < 12) {
        original_slides.forEach(function (slide_el) {
          const clone_el = slide_el.cloneNode(true);
          clone_el.removeAttribute("data-shopify-editor-block");
          wrapper_el.appendChild(clone_el);
        });
        guard += 1;
      }
    }

    const swiper = new window.Swiper(swiper_el, {
      slidesPerView: slides_per_view_m,
      centeredSlides: true,
      loop: loop_enabled,
      speed: reduce_motion ? 0 : speed,
      grabCursor: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      initialSlide: initial_slide,
      spaceBetween: space_between_m,
      breakpoints: {
        768: {
          slidesPerView: slides_per_view,
          centeredSlides: true,
          spaceBetween: space_between
        }
      },
      autoplay:
        enable_autoplay && !reduce_motion
          ? {
              delay: autoplay_delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
      navigation:
        prev_el && next_el
          ? { prevEl: prev_el, nextEl: next_el, disabledClass: "swiper-button-disabled" }
          : false,
      on: {
        init: function () {
          update_thumb({ swiper: this, thumb_el: thumb_el, slide_count: slide_count });
        },
        slideChange: function () {
          update_thumb({ swiper: this, thumb_el: thumb_el, slide_count: slide_count });
        },
        sliderMove: function () {
          update_thumb({ swiper: this, thumb_el: thumb_el, slide_count: slide_count }, true);
        }
      }
    });

    section_instances.set(section_id, {
      swiper: swiper,
      section_el: section_el,
      thumb_el: thumb_el,
      slide_count: slide_count
    });
  }

  function init_all_sections() {
    document.querySelectorAll("[data-jmc-section]").forEach(function (section_el) {
      create_section(section_el);
    });
  }

  function wait_for_swiper(retry) {
    retry = retry || 0;
    if (typeof window.Swiper === "function") {
      init_all_sections();
      return;
    }
    if (retry > 20) return;
    setTimeout(function () {
      wait_for_swiper(retry + 1);
    }, 120);
  }

  document.addEventListener("DOMContentLoaded", function () {
    wait_for_swiper();
  });

  document.addEventListener("shopify:section:load", function (event) {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-jmc-section]") : null;
    if (!section_el) return;
    create_section(section_el);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-jmc-section]") : null;
    if (!section_el) return;
    destroy_section(section_el.dataset.sectionId);
  });

  document.addEventListener("shopify:block:select", function (event) {
    const slide_el =
      event.target && event.target.closest ? event.target.closest(".jq3x-mc__slide") : null;
    if (!slide_el) return;
    const section_el = slide_el.closest("[data-jmc-section]");
    if (!section_el) return;
    const entry = section_instances.get(section_el.dataset.sectionId);
    if (!entry || !entry.swiper) return;

    if (typeof slide_el.dataset.swiperSlideIndex !== "undefined") {
      entry.swiper.slideToLoop(Number(slide_el.dataset.swiperSlideIndex));
    } else {
      const index = Array.prototype.indexOf.call(slide_el.parentNode.children, slide_el);
      entry.swiper.slideTo(index);
    }
  });
})();
